import React from 'react'
import styled, { css } from 'styled-components'

// wraps numbers and letters in spans with a fixed minimum width to force monospace on a font that lacks it.
// used for times, ranks, and chapter names.
// in the case of times, periods/colons do not get monospaced because it looks ugly.
const WithForcedMonospace = ({ children, em = 0.5, decimalEm = 0.68 }) => {
  if (children == null) return null
  if (typeof(children) != 'string' && typeof(children) != 'number') {
    return (children)
  }

  const match = String(children).match(/\.\d+/)
  if (!match) {
    return (
      <>
        {String(children).split('').map((char, i) => (
          /\w/.test(char)
            ? <MonospacedSpan className='monospaced-char' em={em} key={i}>{char}</MonospacedSpan>
            : (
              /\s/.test(char)
              ? <Whitespace em={em} key={i}>&nbsp;</Whitespace>
              : char
            )
        ))}
      </>
    )
  } else {
    const decimals = match[0]
    const preDecimals = String(children).slice(0, match.index)
    return (
      <>
        {preDecimals.split('').map((char, i) => (
          /\w/.test(char)
            ? <MonospacedSpan className='monospaced-char' em={em} key={i}>{char}</MonospacedSpan>
            : (
              /\s/.test(char)
              ? <Whitespace em={em} key={i}>{char}</Whitespace>
              : char
            )
        ))}
        {decimals.split('').map((char, i) => (
          /\w/.test(char)
            ? <MonospacedSpan className='monospaced-char decimal' em={em} decimalEm={decimalEm} key={i}>{char}</MonospacedSpan>
            : (
              /\s/.test(char)
              ? <Whitespace small em={em} key={i}>&nbsp;</Whitespace>
              : char
            )
        ))}
      </>
    )
  }
}

export default WithForcedMonospace

const MonospacedSpan = styled.div`
  display: inline-flex;
  justify-content: center;
  text-align: center;
  align-items: baseline;

  ${props => css`
    min-width: ${props.em}em;
    max-width: ${props.em}em;
    width: ${props.em}em;
  `}

  &.decimal {
    font-size: calc(100% * 2 / 3);
    line-height: 100%;
  }
`

const Whitespace = styled.span`
  min-width: 0.15em;
  max-width: 0.15em;
  width: 0.15em;
  text-align: center;
`
